'use strict';

var vk_bridgeGetAccessToken_index = require('../bridgeGetAccessToken/index.js');
var locals_setVkAccessToken_index = require('../../locals/setVkAccessToken/index.js');
require('@vkontakte/vk-bridge');
require('../getAppId/index.js');
require('../../locals/STATS/index.js');

/**
 * Получаем токен пользователя ВК и сразу записываем его в случае успеха
 * @param {array | string} scope - Массив прав.
 * @return {Promise}
 */
const bridgeGetAccessTokenAndSave = (scope = []) => vk_bridgeGetAccessToken_index(scope)
    .then((response) => {
        locals_setVkAccessToken_index(response.access_token);
        return response.access_token;
    })
    .catch(console.log);

module.exports = bridgeGetAccessTokenAndSave;
